import {
  Drawer as ChakraDrawer,
  DrawerProps as ChakraDrawerProps,
  DrawerOverlay,
  DrawerContent,
} from '@chakra-ui/react';
import React from 'react';

import { TextField } from 'Containers/App/types';
import { COLORS } from 'DesignLibrary/vars';
import Text from 'Shared/Text';

import { DrawerTitleContainer } from './styled';
import { Button } from '../Button';
import { IconTypes } from '../Icon';
import { H5 } from '../typography';

export interface DrawerProps extends ChakraDrawerProps {
  title: string | JSX.Element;
  titleIcon?: IconTypes | JSX.Element;
  vars?: Record<string, unknown>;
  infoType?: string;
}

export const Drawer = ({
  id,
  isOpen,
  title,
  titleIcon,
  size = 'lg',
  finalFocusRef,
  children,
  onClose,
  vars,
  infoType,
}: DrawerProps): JSX.Element => (
  <ChakraDrawer
    id={id}
    isOpen={isOpen}
    placement="right"
    onClose={onClose}
    size={size}
    finalFocusRef={finalFocusRef}
  >
    <DrawerOverlay />
    <DrawerContent sx={{ background: COLORS.gray.white, overflow: 'scroll' }}>
      <DrawerTitleContainer>
        <div className="title">
          {/* ADD SUPPLEMENTAL ICONS COMPONENT HERE WHEN CREATED */}
          {/* <SupplementalIcon type={titleIcon} /> */}
          {titleIcon}
          {infoType !== 'no_deductible' && <H5 as="p">{title}</H5>}
          {infoType === 'no_deductible' && (
            <H5 as="h1">
              <Text field={title as TextField} vars={vars} />
            </H5>
          )}
        </div>
        <Button
          // TODO: Contentful
          aria-label={`Close ${title}`}
          buttonType="standalone"
          iconLeft="X"
          iconProps={{ color: '--text-gray-light' }}
          onClick={onClose}
        />
      </DrawerTitleContainer>
      {children}
    </DrawerContent>
  </ChakraDrawer>
);
